<template>
  <Map
    :external-map-url="props.data.externalMapUrl"
    :project-title="props.data.projectTitle"
    :show-objects="props.data.showObjects" />
</template>

<script setup lang="ts">
import Map from './components/Map.vue'

const props = defineProps({
  data: {
    type: Object,
    required: true
  }
})


</script>
<style scoped>
</style>
